import React from "react";

const LoadingSpinner = ({ size = "large", message = "" }) => {
    const dimensions = size === "small" ? 40 : 80;
    const borderWidth = size === "small" ? 3 : 4;
    
    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        padding: '2rem'
    };
    
    const spinnerStyle = {
        width: `${dimensions}px`,
        height: `${dimensions}px`,
        border: `${borderWidth}px solid #e5e7eb`,
        borderTopColor: '#D4AF37',
        borderRadius: '50%',
        display: 'block',
        boxSizing: 'border-box'
    };
    
    const messageStyle = {
        color: '#6b7280',
        fontSize: '1.1rem',
        margin: 0,
        fontWeight: 500
    };
    
    // Using a ref and requestAnimationFrame for guaranteed animation
    const spinnerRef = React.useRef(null);
    const rotationRef = React.useRef(0);
    
    React.useEffect(() => {
        let animationId;
        
        const animate = () => {
            if (spinnerRef.current) {
                rotationRef.current = (rotationRef.current + 2) % 360;
                spinnerRef.current.style.transform = `rotate(${rotationRef.current}deg)`;
            }
            animationId = requestAnimationFrame(animate);
        };
        
        animationId = requestAnimationFrame(animate);
        
        return () => {
            if (animationId) {
                cancelAnimationFrame(animationId);
            }
        };
    }, []);
    
    return (
        <div style={containerStyle}>
            <div ref={spinnerRef} style={spinnerStyle}></div>
            {message && <p style={messageStyle}>{message}</p>}
        </div>
    );
};

export default LoadingSpinner;
